//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      families: [],
      categories: [],
      selectedFamilies: [],
      selectedCategories: [],
      instockFilter: false,
      familiesOpened: true,
      categoriesOpened: true,
      instockOpened: true,
    };
  },
  methods: {
    toggleFilter(type, term_id) {
      if (type == 'instock') {
        this.instockFilter = !this.instockFilter;
        this.$emit('filter-changed', {
          type: 'instock',
          value: this.instockFilter,
        });
        return;
      }
      const index = this[type].indexOf(term_id);
      if (index > -1) {
        this[type].splice(index, 1);
      } else {
        this[type].push(term_id);
      }
      this.$emit('filter-changed', {
        type: type == 'selectedFamilies' ? 'families' : 'categories',
        value: this[type],
      });
    },
  },
  mounted() {
    WooCommerce.get('products/categories', { per_page: 100 }).then(response => {
      this.categories = response.data;
    });
    WooCommerce.get('products/families', { per_page: 100 }).then(response => {
      this.families = response.data;

      const url = new URL(window.location.href);
      const family = url.searchParams.get('rodinky');
      if (family) {
        const families = family.split(',');
        families.forEach(single => {
          const found = this.families.find(one => one.slug == single);
          if (typeof found !== 'undefined') {
            this.toggleFilter('selectedFamilies', found.term_id);
          }
        });
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/catalog/Sidebar.vue